import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

export default function Layout({ cartCount, onOpenCart }) {
  return (
    <div className="flex flex-col min-h-screen bg-smoke text-linen font-sans selection:bg-ember selection:text-white">
      <Navbar cartCount={cartCount} onOpenCart={onOpenCart} />
      <div className="flex-grow">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}